import { Component } from '@angular/core';

@Component({
  selector: 'app-emptycart',
  templateUrl: './emptycart.component.html',
  styleUrl: './emptycart.component.scss'
})
export class EmptycartComponent {
   
   ngOnInit(): void {
       window.scrollTo({ top: 0, behavior: 'smooth' });

  }
}
